var Component = require("/home/travis/build/tonyhhyip/library/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MarkdownCard.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2070f088!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MarkdownCard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./assets/js/component/MarkdownCard.vue
// module id = 5
// module chunks = 0